module.exports = __webpack_public_path__ + "img/parallax1-450p.8f4afa60.jpg";